import { render, staticRenderFns } from "./NewRealEstateBuildingComparativeEdit.vue?vue&type=template&id=d242b260&scoped=true&"
import script from "./NewRealEstateBuildingComparativeEdit.vue?vue&type=script&lang=js&"
export * from "./NewRealEstateBuildingComparativeEdit.vue?vue&type=script&lang=js&"
import style0 from "./NewRealEstateBuildingComparativeEdit.vue?vue&type=style&index=0&id=d242b260&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d242b260",
  null
  
)

export default component.exports